import { FC, ReactElement } from "react";

export const Section: FC<{ children: ReactElement | ReactElement[], id?: string }> = ({ children, id }) => (
	<div id={id} className="container my-10 mb-60 relative">{...Array.isArray(children) ? children : [children]}</div>
);